// @flow
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import type { StateType, DispatchType } from "../../global/types/redux";
import { GeneralModalForm, LoadingProgress, AppHeader } from "imagus-components";
import { updateUser } from "../../actions/userActions";
import { userChangePassword } from "../../actions/profileActions";
import AccountInformation from "../../components/profiles/AccountInformation";
import ChangePasswordForm from "../../components/profiles/ChangePasswordForm";
import UserProfileForm from "../../components/profiles/UserProfileForm";

import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import EditIcon from "@material-ui/icons/Edit";

type AccountProfileStatesType = {
  profileModal: boolean,
  passwordModal: boolean
};

type AccountProfilePropsType = {
  user: { [key: string]: * },
  actions: {
    updateUser: Function,
    userChangePassword: Function
  }
};

class AccountProfile extends Component<
  AccountProfilePropsType,
  AccountProfileStatesType
> {
  constructor(props: AccountProfilePropsType) {
    super(props);
    this.state = {
      profileModal: false,
      passwordModal: false
    };
  }

  switchModalStatus = (modalName: string): * => (status: boolean): * => {
    this.setState({ [modalName]: status });
  };

  setUpdateUser = (
    firstName: string,
    lastName: string,
    facebaseUid: string,
    doneCall: Function,
    failCall: Function
  ) => {
    this.props.actions.updateUser(
      firstName,
      lastName,
      facebaseUid,
      doneCall,
      failCall
    );
  };

  userChangePassword = (
    oldPassword: string,
    newPassword: string,
    doneCall: Function,
    failCall: Function
  ) => {
    this.props.actions.userChangePassword(
      oldPassword,
      newPassword,
      doneCall,
      failCall
    );
  };

  render(): * {
    if (this.props.user.auth && !this.props.user.fetchingAuth) {
      return (
        <Fragment>
          <AppHeader
            actions={[
              <IconButton
                onClick={(): Function =>
                  this.switchModalStatus("profileModal")(true)
                }
              >
                <EditIcon className="shine-icon medium-icon" />
              </IconButton>,
              <Button
                type="button"
                variant="contained"
                color="primary"
                className="dark-btn"
                onClick={(): Function =>
                  this.switchModalStatus("passwordModal")(true)
                }
              >
                <LockOpenIcon className="light-icon right-margin-5" />
                Change Password
              </Button>
            ]}
            title="My Profile"
          />
          <GeneralModalForm
            title="Change Your Password"
            open={this.state.passwordModal}
            handleModalStatus={this.switchModalStatus("passwordModal")}
            form={
              <ChangePasswordForm
                onClose={(): Function =>
                  this.switchModalStatus("passwordModal")(false)
                }
                userChangePassword={this.userChangePassword}
              />
            }
          />
          <GeneralModalForm
            title="Update Your Profile"
            open={this.state.profileModal}
            handleModalStatus={this.switchModalStatus("profileModal")}
            form={
              <UserProfileForm
                onClose={(): Function =>
                  this.switchModalStatus("profileModal")(false)
                }
                user={this.props.user}
                setUpdateUser={this.setUpdateUser}
              />
            }
          />
          <AccountInformation
            user={this.props.user}
            openProfileFrom={(): Function =>
              this.switchModalStatus("profileModal")(true)
            }
          />
        </Fragment>
      );
    } else {
      return <LoadingProgress />;
    }
  }
}

const mapStateToProps = (state: StateType): * => ({
  user: state.v3account.user
});

const mapDispatchToProps = (dispatch: DispatchType): DispatchType => ({
  actions: bindActionCreators({ updateUser, userChangePassword }, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountProfile);
